export enum SpecialUserPermissions {
    None = 0,
    ShowHistoricalPlots = 1,
    ManageVehicles = 2,
    ManageDrivers = 4,
    ManageGeofences = 8,
    ManageGroups = 16,
    ManageAlerts = 32,
    ShowReports = 64,
    ManageReportBuilder = 128,
    ManageAlertReviews = 256,
    All = ~None
}
